import React from 'react'
import MailLogRow from "./MailLogRow";
import Api from '../../../services/Api'
import { useState, useEffect } from 'react';


const MailsHistory = ({siteId}) => {

    const [history, setHistory] = useState([]);

    useEffect(() => {
        getHistory();
    }, [])
    

    const getHistory = () =>
    {
        Api.get(`/siteHistory?siteId=${siteId}&getMailsHistory=true`)
        .then(res => res.data)
        .then(data => {
            setHistory(data);
        })
        .catch((error) => {
        });
    }

    const list = history.map((x, index) => {
        return  <MailLogRow 
                    key={index}
                    even={index % 2 === 0}
                    date={x.date}
                    status={x.status}
                    scenario={x.scenario}
                    subject={x.subject}
                />
    })

    return(
        <div style={{padding: '10px 0', minWidth: 500}}>
            {list}
        </div>
    );
}
export default MailsHistory


// WEBPACK FOOTER //
// ./src/components/Administration/SiteDetails/MailsHistory.js